module.exports = __webpack_public_path__ + "img/Virtual_Assets_and_Crypto.c98ebf00.png";